import { ExpandMore } from "@mui/icons-material"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Drawer,
  List,
  ListItem,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material"
import React from "react"
import { useState, useEffect } from "react"
import { getActivity, getDailyScheduleData } from "../../api"
import { useContext } from "react"
import UserContext from "../../contexts/user"
import PersonAddIcon from "@mui/icons-material/PersonAdd"
import NoteAddIcon from "@mui/icons-material/NoteAdd"
import EventIcon from "@mui/icons-material/Event"
import FeedbackIcon from "@mui/icons-material/Feedback"
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts"
import PaymentsIcon from "@mui/icons-material/Payments"
import PaidIcon from "@mui/icons-material/Paid"
import MoneyOffIcon from "@mui/icons-material/MoneyOff"
import ViewInArIcon from "@mui/icons-material/ViewInAr"
import InventoryIcon from "@mui/icons-material/Inventory"
import InfScroll from "../ui/InfScroll"
import { formatDateAgo } from "../../utilities"

const drawerWidth = 250
export const DailySchedule = () => {
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
          zIndex: 900,
        },
        display: {
          xs: "none",
          sm: "block",
        },
        p: 0,
      }}
      variant="permanent"
      anchor="right"
    >
      <DailyScheduleMain />
    </Drawer>
  )
}

export const DailyScheduleMain = () => {
  const { userRole } = useContext(UserContext)
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(0)
  const [totalPages, setTotalPages] = useState(null)

  const getApi = () => {
    const options = {
      page,
      fromDate: new Date(),
      toDate: null,
      sort: {
        field: "creationTimestamp",
        order: "desc",
      },
    }
    return userRole === "ADMIN"
      ? getActivity(options)
      : getDailyScheduleData(options)
  }

  const fetchData = () => {
    getApi()
      .then((res) => {
        setData([...data, ...res.data.rows])
        setCount(res.data.count)
        setTotalPages(Math.max(res.data.totalPages, 1))
      })
      .catch((err) => {
        setTotalPages(page)
        console.log(err)
      })
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, userRole])
  return (
    <Box id="activity-box" sx={{ height: "100vh", overflow: "auto" }}>
      <Toolbar />
      <Box sx={{ p: "10px 20px" }}>
        <Typography sx={{ fontWeight: 800 }}>
          {userRole === "ADMIN" ? "Activity" : "Daily Schedule"}
        </Typography>
      </Box>

      {userRole === "ADMIN" ? (
        <InfScroll
          next={() => setPage(page + 1)}
          hasMore={page !== totalPages}
          count={count}
          target="activity-box"
        >
          {data?.map((d, i) => (
            <Activity key={i} data={d} />
          ))}
        </InfScroll>
      ) : (
        <>
          <Schedule title={"Classes"} events={data?.classes?.rows || []} />
          <Schedule
            title={"Assignments"}
            events={data?.assignments?.rows || []}
          />
          <Schedule title={"Exams"} events={data?.exams?.rows || []} />
        </>
      )}
    </Box>
  )
}

const activityIconMap = {
  NEW_ADMISSION_EVENT: <NoteAddIcon color="primary" />,
  NEW_EVENT: <EventIcon color="primary" />,
  NEW_NOTICE: <FeedbackIcon color="primary" />,
  NEW_STUDENT: <PersonAddIcon color="primary" />,
  NEW_STAFF: <ManageAccountsIcon color="primary" />,
  NEW_FEE_PAYMENT: <PaymentsIcon color="primary" />,
  NEW_INCOME: <PaidIcon color="primary" />,
  NEW_EXPENSE: <MoneyOffIcon color="primary" />,
  NEW_ASSET: <ViewInArIcon color="primary" />,
  NEW_INVENTORY: <InventoryIcon color="primary" />,
}

const Activity = ({ data }) => (
  <Accordion>
    <AccordionSummary expandIcon={<ExpandMore />} sx={{ px: 1 }}>
      <Stack direction="row" gap={2}>
        <Stack alignItems="center" sx={{ flex: "none" }}>
          <Typography sx={{ fontSize: 10, fontWeight: 500 }}>
            {formatDateAgo(data?.creationTimestamp)}
          </Typography>
          {activityIconMap?.[data?.type]}
        </Stack>
        <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
          {data?.title}
        </Typography>
      </Stack>
    </AccordionSummary>
    <AccordionDetails>
      <Typography sx={{ fontSize: 12 }}>{data?.content}</Typography>
    </AccordionDetails>
  </Accordion>
)

const Schedule = ({ title, events }) => (
  <Accordion>
    <AccordionSummary
      sx={{
        "& .Mui-expanded": { my: "0px !important" },
        minHeight: "10px !important",
      }}
      expandIcon={<ExpandMore />}
      aria-controls="panel1a-content"
      id="panel1a-header"
    >
      <Typography>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ p: "0 5px" }}>
      <List>
        {events?.map((event) => (
          <ListItem className="col" sx={{ alignItems: "flex-start" }}>
            <Typography sx={{ mb: "10px" }} fontWeight={"bold"}>
              {event.name}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Topic Name
            </Typography>
            <Typography
              sx={{ mb: "10px" }}
              variant="body1"
              color="text.secondary"
            >
              {event.time}
            </Typography>
            {event.button}
          </ListItem>
        ))}
      </List>
    </AccordionDetails>
  </Accordion>
)
